import React, { useEffect } from "react";

import { useNewReleaseNotes } from "@Hooks/useNewReleaseNotes";

import BlogList from "./BlogList";

const ReleaseNotes: React.FC = () => {
  const { markReleaseNotesSeen, latestPost } = useNewReleaseNotes();

  useEffect(() => {
    markReleaseNotesSeen();
  }, [latestPost?.createdAt]);

  return <BlogList />;
};

export default ReleaseNotes;
